import { canUseDOM } from '@lib/canUseDOM';

let length = 1;

if (canUseDOM) {
    window.addEventListener('popstate', () => {
        --length;
    }, {
        capture: true,
    });

    const oldPushState = history.pushState;

    history.pushState = function(...args) {
        length++;

        return oldPushState.apply(history, args);
    };
}

export function getHistoryLength() {
    return length;
}
